import { render } from "./Btn1.vue?vue&type=template&id=7cd13950"
import script from "./Btn1.vue?vue&type=script&lang=js"
export * from "./Btn1.vue?vue&type=script&lang=js"

import "./Btn1.vue?vue&type=style&index=0&id=7cd13950&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__